import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {FormsModule} from '@angular/forms';
import {MatIconModule} from "@angular/material/icon";
import {MatDialog} from '@angular/material/dialog';
import {ImageModalComponent} from "../dialog/image-modal.component";

/** The insurance information for a patient */
@Component({
	selector: 'app-image-upload',
	imports: [
		CommonModule,
		MatFormFieldModule,
		MatSelectModule,
		MatInputModule,
		FormsModule,
		MatIconModule
	],
	templateUrl: './image-upload.component.html',
	styleUrl: './image-upload.component.scss',
})


export class ImageUploadComponent {


	constructor(public dialog:MatDialog) {
	}

	@Input() imageSrc:string | ArrayBuffer | null = null;
	@Input() label:string = "";
	@Input() target:any;
	@Input() field:string;

	onDragOver(event:DragEvent):void {
		event.preventDefault();
	}

	onDropSuccess(event:DragEvent):void {
		event.preventDefault();
		const files = event.dataTransfer?.files;
		if(files && files.length > 0) {
			this.handleFiles(files);
		}
	}

	onChange(event:Event):void {
		const input = event.target as HTMLInputElement;
		if(input.files && input.files.length > 0) {
			this.handleFiles(input.files);
		}
	}

	private handleFiles(files:FileList):void {
		const file = files[0];

		const reader = new FileReader();
		reader.onload = e => {
			this.imageSrc = e.target?.result || null;
			if(this.target) {
				this.target[this.field] = this.imageSrc;
			}
		};
		reader.readAsDataURL(file);
	}

	openDialog():void {
		const dataURL = this.imageSrc;
		this.dialog.open(ImageModalComponent, {
			data: {imageUrl: dataURL},
			maxHeight: '768px',
			maxWidth: '1024px',
			height: '90%',
			width: '90%',
			panelClass: 'transparent-dialog-background',
			backdropClass: 'mat-dialog-backdrop',
			hasBackdrop: true
		});
	}

	protected clearTarget() {
		this.target[this.field] = null;
		this.target[`${this.field}Delete`] = true;
	}
}
